import React, { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
import "./otpReceive.css";
import { connect } from "react-redux";
import * as actionCreators from '../../modules/actions/index'
import * as url from '../../utils/url'
import axios from '../../axios'
import { saveToken } from '../../utils/localStorage'
import { toastContainer } from "../../utils/toast";

const TwoFactorAuth = ({
  history,
  onLoginSuccess
}) => {
  const [code, setCode] = useState("");
  const inputRef = useRef(null);
  const [isLoading,setIsLoading]=useState(false)
  const [isInvalid,setIsInvalid]=useState(false)
  const value = localStorage.getItem("mfaContext")||{}
  const user=JSON.parse(value)
  const phoneNumber=history.location&&history.location.state?history.location.state.mobileNumber:''


  useEffect(() => {
    inputRef.current && inputRef.current.focus();
  }, []);

  const isValid = /^\d{6}$/.test(code);

  function handleChange(e) {
    const next = e.target.value.replace(/\D/g, "").slice(0, 6);
    setCode(next);
  }


    const onMobileNumberVerify=(userdata,data)=>{
    if(phoneNumber){
            const paylaod={
                email:userdata.email,
                otp:userdata.otp,
                mobileNumber:phoneNumber
            }
            axios.post(url.sentOtpForPhone,paylaod).then(({response})=>{
                 toastContainer('Mobile number verified and saved','success')
                   saveToken(data.autherizationToken)
              onLoginSuccess({
            ...data.userDetails,
            autherizationToken: data.autherizationToken,
          })
          localStorage.removeItem('mfaContext');
          setIsLoading(false)
    
            }).catch((err)=>{

          
              const isdublicationError=err.response&&err.response.data&& err.response.data.errors&&err.response.data.errors.error.name=='MongoError'
                if(isdublicationError){
                   toastContainer('Provided number is already exist','error')
                }else{
                   toastContainer('Something went wrong','error')
                }
            })
        }
        
  }

  async function handleSubmit(e) {

    setIsInvalid(false)
    e.preventDefault();
    if (!isValid || isLoading) return;
    
        const payload={
            otp:code,
            email:user.email
        }

        setIsLoading(true)

          axios.post(url.verifyOTP,payload).then(({data}) => {
             if(phoneNumber){
              onMobileNumberVerify(payload,data)
            
            }else{
                saveToken(data.autherizationToken)
              onLoginSuccess({
            ...data.userDetails,
            autherizationToken: data.autherizationToken,
          })
          setIsLoading(false)
          localStorage.removeItem('mfaContext');
              
            }

            

            }).catch((eer)=>{
                setIsInvalid(true)
                setIsLoading(false)
                console.log("errrorr:", eer)
            })

  }





  const onResend = () => {
    const payload={mobileNumber:user.mobileNumber||phoneNumber,email:user.email}
      axios.post(url.resendOTP, payload)
        .then((response) => {
            console.log("resoponse",response)
        })
                    

  }

  return (
    <div className="tfa">
      <div className="tfa__wrap">
        <button type="button" className="tfa__resend" onClick={()=>history.push('/login')}>
         <span className="tfa__caret">‹</span> Back to login 
        </button>
        <h1 className="tfa__title">Two–Factor Authentication</h1>

        <p className="tfa__desc">
          Your account is protected with two-factor authentication. We’ve sent
          you a text message. Please enter the code below.
        </p>

        <form className="tfa__form" onSubmit={handleSubmit}>
          <label htmlFor="tfa-code" className="tfa__label">
            <span className="tfa__dot" aria-hidden="true" />
            <span>Two-Factor Code</span>
          </label>

          <input
            id="tfa-code"
            ref={inputRef}
            className="tfa__input"
            value={code}
            onChange={handleChange}
            inputMode="numeric"
            pattern="[0-9]*"
            autoComplete="one-time-code"
            aria-label="Two-Factor Code"
            placeholder=""
          />
          {isInvalid&&<p className="color-orange">
            Invalid OTP
          </p>}

          <button
            type="submit"
            className="tfa__button"
            disabled={!isValid || isLoading}
          >
            {isLoading ? "Verifying…" : "Continue"}
          </button>
        </form>

        <button type="button" className="tfa__resend" onClick={onResend}>
          Resend code via text message <span className="tfa__caret">›</span>
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchEnterpriseObjectives: (data) =>
      dispatch(actionCreators.storeEnterpriseObjectives(data)),
    onLoginSuccess: (data) => dispatch(actionCreators.loginSuccess(data)),

  };
};

export default connect(mapStateToProps,mapDispatchToProps)(TwoFactorAuth);
